import { publicClient, privateClient } from './client';

const createSession = data => publicClient.post('/v1/sessions/', JSON.stringify(data));

const fetchClientBySession = (sessionid, headers) => privateClient(sessionid).get('/v2/customer', headers);

const requestToken = (plan, sessionId) =>
  privateClient(sessionId).post('/v1/token/', JSON.stringify({ plan }));

const verifyToken = (plan, token, sessionId) =>
  privateClient(sessionId).post('/v1/token/verify/', { plan, token });

const requestLogin = data => publicClient.post('/v1/sessions/', JSON.stringify(data));

export { createSession, requestToken, verifyToken, requestLogin, fetchClientBySession };
